// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { markdown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-markdown': IconMarkdown;
    }
}

/**
 * The icon component for the 'markdown' icon
 */
export class IconMarkdown extends IconSvg {
    public constructor() {
        super(markdown16X16);
    }
}

registerIconSvg('icon-markdown', IconMarkdown);
export const iconMarkdownTag = 'nimble-icon-markdown';
